<template>
  <md-card class="md-card-profile">
    <div class="md-card-avatar">
      <div class="picture-container">
        <div class="picture">
          <div v-if="!picture">
            <img :src="cardUserImage" class="picture-src" title="" />
          </div>
          <div v-else>
            <img :src="picture" />
          </div>
        </div>
      </div>
    </div>
    <md-card-content class="md-size-50 mx-auto" v-if="!userID">
      <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
    </md-card-content>
    <md-card-content v-if="userID">
      <h5 class="category text-primary"><b>Student</b></h5>
      <h5 class="card-title">
        <b>Full Name :</b> {{ first_name }} {{ last_name }}
      </h5>
      <h5 class="card-title"><b>Email :</b> {{ email }}</h5>
      <h5 class="card-title"><b>Gender :</b> {{ gender }}</h5>
      <h5 class="card-title"><b>Phone :</b> {{ mobile_phone }}</h5>
      <h5 class="card-title"><b>Country :</b> {{ country }}</h5>
      <h5 class="card-title"><b>Created Date :</b> {{ date_joined }}</h5>
      <h4 class="category- text-primary"><b>Student Details</b></h4>
      <h5 class="card-title" v-if="info.agency">
        <b>Agency :</b> {{ info.agency.name }}
      </h5>
      <h5 class="card-title"><b>Mother Name :</b> {{ info.mother_name }}</h5>
      <h5 class="card-title"><b>Father Name :</b> {{ info.father_name }}</h5>
      <h5 class="card-title"><b>Birth Date :</b> {{ info.birth_date }}</h5>
      <h5 class="card-title">
        <b>City of Residence :</b> {{ info.city_of_residence }}
      </h5>
      <h5 class="card-title">
        <b>Passport date of issue :</b> {{ info.passport_date_of_issue }}
      </h5>
      <h5 class="card-title">
        <b>Passport date of expire :</b> {{ info.passport_date_of_expire }}
      </h5>
      <h5 class="card-title">
        <b>Passport Number :</b> {{ info.passport_number }}
      </h5>
      <md-button
        class="md-success md-round"
        @click.native="handleDetail(userID)"
        >User Detail</md-button
      >
    </md-card-content>
  </md-card>
</template>
<script>
export default {
  props: {
    cardUserImage: {
      type: String,
      default: "/img/default-avatar.png"
    },
    buttonColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      first_name: null,
      last_name: null,
      email: null,
      gender: null,
      mobile_phone: null,
      picture: null,
      date_joined: null,
      country: null,
      info: null,
      userID: null
    };
  },
  methods: {
    getColorButton: function(buttonColor) {
      return "md-" + buttonColor + "";
    },
    handleDetail: function(id) {
      this.$router.push({ name: "Student User Update", params: { id: id } });
    }
  }
};
</script>
<style>
body
  > div
  > div.main-panel
  > div.content
  > div
  > div:nth-child(2)
  > div
  > div.md-card-content
  > h5.card-title {
  margin: 20px;
}
</style>
